module.exports = __webpack_public_path__ + "img/builder-9.b4d1e7e7.jpg";